import { useEffect } from 'react';

export default function usePageTitle(pageName) {
  useEffect(() => {
    document.title = pageName
      ? `Siberat Customer | ${pageName}`
      : 'Siberat Customer';
  }, [pageName]);
}
